import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useObserver } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { DownloadResume } from '../resume_output';

const Resume15 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload} />
      <div className="w-full mx-auto my-10 bg-white shadow-lg border border-gray-300" ref={resumeRef}>
        <div className="flex items-center p-6 bg-[#f0f4fa]">
          <div className="w-32 h-32 mr-6">
            <img
              className="rounded-full object-cover w-full h-full"
              src={ResumeStore?.resumeBuilder.profile || 'https://via.placeholder.com/120'}
              alt="Profile Picture"
            />
          </div>
          <div className="text-left">
            <h1 className="text-3xl font-bold text-gray-800">{ResumeStore?.resumeBuilder.personalDetails.firstName} {ResumeStore?.resumeBuilder.personalDetails.lastName}</h1>
            <h2 className="text-xl font-normal text-gray-600">{ResumeStore?.resumeBuilder.personalDetails.jobTitle}</h2>
          </div>
        </div>
        <div className="flex p-6">
          <div className="w-1/3 pr-6 border-r border-gray-300">
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-gray-800 border-b-2 border-gray-400 pb-2">About Me</h2>
              <p className="text-gray-700">{ResumeStore?.resumeBuilder.profileSummary}</p>
            </div>
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-gray-800 border-b-2 border-gray-400 pb-2">Contact</h2>
              <p className="text-gray-700">{ResumeStore?.resumeBuilder.personalDetails.email}</p>
              <p className="text-gray-700">{ResumeStore?.resumeBuilder.personalDetails.phone}</p>
              <p className="text-gray-700">{ResumeStore?.resumeBuilder.personalDetails.address}</p>
            </div>
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-gray-800 border-b-2 border-gray-400 pb-2">Languages</h2>
              {ResumeStore?.resumeBuilder.languages.map((language, index) => (
                <p key={index} className="text-gray-700">{language.language}</p>
              ))}
            </div>
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-gray-800 border-b-2 border-gray-400 pb-2">Interests</h2>
              {ResumeStore?.resumeBuilder.hobbies.map((hobby, index) => (
                <p key={index} className="text-gray-700">{hobby}</p>
              ))}
            </div>
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-gray-800 border-b-2 border-gray-400 pb-2">Achievements</h2>
              {ResumeStore?.resumeBuilder.extraCurricularActivities.map((achievement, index) => (
                <p key={index} className="text-gray-700">{achievement.functionTitle}</p>
              ))}
            </div>
          </div>
          <div className="w-2/3 pl-6">
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-gray-800 border-b-2 border-gray-400 pb-2">Skills</h2>
              {ResumeStore?.resumeBuilder.skills.map((skill, index) => (
                <div key={index} className="flex items-center mb-4">
                  <p className="w-32 text-gray-700">{skill}</p>
                </div>
              ))}
            </div>
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-gray-800 border-b-2 border-gray-400 pb-2">Education</h2>
              {ResumeStore?.resumeBuilder.education.map((edu, index) => (
                <div key={index} className="mb-4">
                  <h3 className="text-lg font-semibold text-gray-800">{edu.degree}</h3>
                  <p className="text-gray-700">{edu.school} | {edu.startDate} - {edu.endDate}</p>
                  <p className="text-gray-700">{edu.description}</p>
                </div>
              ))}
            </div>
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-gray-800 border-b-2 border-gray-400 pb-2">Organizations</h2>
              {ResumeStore?.resumeBuilder.extraCurricularActivities.map((activity, index) => (
                <p key={index} className="text-gray-700">{activity.functionTitle}</p>
              ))}
            </div>
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-gray-800 border-b-2 border-gray-400 pb-2">Expectations</h2>
              {ResumeStore?.resumeBuilder?.courses.map((course, index) => (
                <p key={index}>{course.course}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  ));
}

export default Resume15;
